import { StorageValue } from './storage-value';

export abstract class CacheStorageAbstract {
    public abstract getItem<T>(key: string): StorageValue<T>;

    public abstract setItem<T>(key: string, value: StorageValue<T>): boolean;

    public abstract removeItem(key: string): void;

    public abstract clear(): void;
}
